import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useOutletContext, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import { Modal, Button, Space, message, Tooltip, Dropdown } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import "./Blogs.css";
import { db, auth, storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, getDocs, onSnapshot, doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove, addDoc, serverTimestamp, query, orderBy, where } from "firebase/firestore";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
const ASSETS = {
  logoGraphic: "/Nabi UI Assets/Assets_Images/Logo placeholder.png",
  icons: {
    arrowLeft: "/Nabi UI Assets/Assets_Icon/Icon_Double arrow left.svg",
    arrowRight: "/Nabi UI Assets/Assets_Icon/Icon_Double arrow right.svg",
    search: "/Nabi UI Assets/Assets_Icon/Icon_Search.svg"
  }
};

const VoiceCarousel = ({ voices, onVoiceClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const carouselItems = voices || [];
  const safeIndex = carouselItems.length > 0 ? currentIndex % carouselItems.length : 0;

  useEffect(() => {
    if (carouselItems.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
    }, 5000); // 5 seconds autoplay
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  if (!carouselItems || carouselItems.length === 0) return null;

  const getVisibleItems = () => {
    const total = carouselItems.length;
    if (total === 1) return [carouselItems[0]];
    if (total === 2) return [carouselItems[0], carouselItems[1]];
    
    // For 3 or more items, we want previous, current, next
    const prev = (safeIndex - 1 + total) % total;
    const curr = safeIndex;
    const next = (safeIndex + 1) % total;
    
    return [
      { item: carouselItems[prev], position: 'prev' },
      { item: carouselItems[curr], position: 'curr' },
      { item: carouselItems[next], position: 'next' }
    ];
  };

  const visibleItems = getVisibleItems();

  return (
    <div className="voice-carousel-container">
      <div className="voice-carousel-dots">
        {carouselItems.map((_, index) => (
          <div 
            key={index} 
            className={`voice-carousel-dot ${index === safeIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
      
      <div className="voice-carousel-track">
        <AnimatePresence mode="popLayout">
          {carouselItems.length >= 3 ? visibleItems.map(({ item, position }) => {
            let className = "voice-carousel-item";
            if (position === 'curr') className += " active";
            else if (position === 'prev') className += " prev";
            else if (position === 'next') className += " next";

            return (
              <motion.div
                key={item.id || item.name}
                className={className}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ 
                  opacity: position === 'curr' ? 1 : 0.6,
                  scale: position === 'curr' ? 1 : 0.85,
                  x: position === 'curr' ? '0%' : (position === 'prev' ? '-110%' : '110%'),
                  zIndex: position === 'curr' ? 10 : 1,
                  filter: position === 'curr' ? 'blur(0px)' : 'blur(4px)'
                }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                onClick={() => {
                  if (position === 'prev') setCurrentIndex((safeIndex - 1 + carouselItems.length) % carouselItems.length);
                  else if (position === 'next') setCurrentIndex((safeIndex + 1) % carouselItems.length);
                  else if (position === 'curr' && onVoiceClick) onVoiceClick(item);
                }}
              >
                <div className="voice-item-content">
                  <div className="voice-item-image" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#2c3e50', color: '#fff', fontSize: '1.5rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', textAlign: 'center', padding: '20px' }}>
                    Coming Soon
                  </div>
                  {/* Temporarily hidden as per request
                  {position === 'curr' && (
                    <>
                      <div className="voice-item-overlay"></div>

                      <div className="voice-item-text">
                        <p>{item.voiceHeader || item.text || item.description}</p>
                      </div>
                    </>
                  )}
                  */}
                </div>
                {/* Temporarily hidden as per request
                <div className="voice-item-details">
                  <h4>{item.name}</h4>
                  <p>{item.location}</p>
                </div>
                */}
              </motion.div>
            );
          }) : (
             // Simple fallback for 1 or 2 items
             <div className="voice-carousel-simple">
               <div className="voice-carousel-item active" onClick={() => onVoiceClick && onVoiceClick(carouselItems[safeIndex])}>
                 <div className="voice-item-content">
                  <div className="voice-item-image" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#2c3e50', color: '#fff', fontSize: '1.5rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', textAlign: 'center', padding: '20px' }}>
                    Coming Soon
                  </div>
                  {/* Temporarily hidden as per request
                  <div className="voice-item-overlay"></div>

                  <div className="voice-item-text">
                    <p>{carouselItems[safeIndex].voiceHeader || carouselItems[safeIndex].text || carouselItems[safeIndex].description}</p>
                  </div>
                  */}
                 </div>
                 {/* Temporarily hidden as per request
                 <div className="voice-item-details">
                  <h4>{carouselItems[safeIndex].name}</h4>
                  <p>{carouselItems[safeIndex].location}</p>
                 </div>
                 */}
               </div>
             </div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default function Blogs({ onConnect }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const context = useOutletContext();
  const setIsLoginOpen = context?.setIsLoginOpen;

  const initialNewsletter = searchParams.get('newsletter') || null;

  const [openNewsletterState, setOpenNewsletterState] = useState(initialNewsletter);
  const [blogopenState, setblogOpenState] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState(1);
  const [selectedThread, setSelectedThread] = useState(null);
  const [voiceFormData, setVoiceFormData] = useState({ title: "", story: "", name: "", location: "" });
  const [voiceImageFile, setVoiceImageFile] = useState(null);
  const [isSubmittingStory, setIsSubmittingStory] = useState(false);
  const [submitStoryMessage, setSubmitStoryMessage] = useState("");

  const handleSubmitStory = async () => {
    if (!auth.currentUser) {
      setSubmitStoryMessage("Please log in to submit your story.");
      if (setIsLoginOpen) setIsLoginOpen(true);
      return;
    }

    if (!voiceFormData.story.trim() || !voiceFormData.title.trim()) {
      setSubmitStoryMessage("Please provide at least a title and your story.");
      return;
    }
    setIsSubmittingStory(true);
    setSubmitStoryMessage("");

    try {
      let thumbnailUrl = "";
      if (voiceImageFile) {
        const imgRef = ref(storage, `voicesimage/${Date.now()}_${voiceImageFile.name}`);
        await uploadBytes(imgRef, voiceImageFile);
        thumbnailUrl = await getDownloadURL(imgRef);
      }

      await addDoc(collection(db, "user_submitted_voices"), {
        id: Date.now(),
        name: voiceFormData.name || "Anonymous",
        location: voiceFormData.location || "Community",
        category: selectedThread || "",
        voiceHeader: voiceFormData.title,
        text: voiceFormData.story,
        thumbnailUrl: thumbnailUrl,
        status: "pending",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      setSubmitStoryMessage("Your story has been submitted successfully and is pending review!");
      setTimeout(() => {
        setIsShareModalOpen(false);
        setModalStep(1);
        setSelectedThread(null);
        setVoiceFormData({ title: "", story: "", name: "", location: "" });
        setVoiceImageFile(null);
        setSubmitStoryMessage("");
      }, 3000);
    } catch (error) {
      console.error("Error submitting story:", error);
      setSubmitStoryMessage("Error submitting story. Please try again.");
    } finally {
      setIsSubmittingStory(false);
    }
  };
  const [selectedArticleState, setSelectedArticleState] = useState(null);

  const navigate = useNavigate();

  const handleVoiceClick = (voice) => {
    // Temporarily disabled as per request
    // navigate('/voice-story', { state: { voice } });
  };

  const openNewsletter = openNewsletterState;
  const blogopen = blogopenState;
  const selectedArticle = selectedArticleState;

  const setOpenNewsletter = (val) => {
    setOpenNewsletterState(val);
    if (val) searchParams.set('newsletter', val);
    else searchParams.delete('newsletter');
    setSearchParams(searchParams, { replace: true });
  };

  const setblogOpen = (val) => {
    setblogOpenState(val);
    if (!val) {
      searchParams.delete('article');
      setSearchParams(searchParams, { replace: true });
    }
  };

  const setSelectedArticle = (article) => {
    setSelectedArticleState(article);
    if (article) {
      searchParams.set('article', article.id);
      setSearchParams(searchParams, { replace: true });
    }
  };
  const [showPdf, setShowPdf] = useState(false);
  const [hoverSearch, setHoverSearch] = useState(false);
  const [hoverSort, setHoverSort] = useState(false);
  const [activeSection, setActiveSection] = useState('story');
  const [dynamicBlogs, setDynamicBlogs] = useState([]);
  const [dynamicNewsletters, setDynamicNewsletters] = useState([]);
  const [dynamicQuotes, setDynamicQuotes] = useState([]);
  const [dynamicVoices, setDynamicVoices] = useState([]);

  // Interactions State
  const [likesCount, setLikesCount] = useState(0);
  const [isLiked, setIsLiked] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [isLikesModalOpen, setIsLikesModalOpen] = useState(false);
  const [likedByUIDs, setLikedByUIDs] = useState([]);
  const [likedUsersDetails, setLikedUsersDetails] = useState([]);



  useEffect(() => {
    const unsubscribeBlogs = onSnapshot(collection(db, "blogs"), (querySnapshot) => {
      const fetched = querySnapshot.docs.map(doc => ({ ...doc.data() }));
      setDynamicBlogs(fetched);
    }, (error) => {
      console.error("Error fetching dynamic blogs:", error);
    });

    const unsubscribeNewsletters = onSnapshot(collection(db, "newsletters"), (querySnapshot) => {
      const fetched = querySnapshot.docs.map(doc => ({ ...doc.data() }));
      fetched.sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
      setDynamicNewsletters(fetched);
    }, (error) => {
      console.error("Error fetching newsletters:", error);
    });

    const unsubscribeVoices = onSnapshot(collection(db, "voices"), (querySnapshot) => {
      const fetchedVoices = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setDynamicVoices(prev => {
        const userVoices = prev.filter(v => v.isUserSubmitted);
        return [...userVoices, ...fetchedVoices];
      });
    }, (error) => {
      console.error("Error fetching voices:", error);
    });

    const unsubscribeUserVoices = onSnapshot(query(collection(db, "user_submitted_voices"), where("status", "==", "approved")), (querySnapshot) => {
      const fetchedUserVoices = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), isUserSubmitted: true }));
      setDynamicVoices(prev => {
        const adminVoices = prev.filter(v => !v.isUserSubmitted);
        return [...fetchedUserVoices, ...adminVoices];
      });
    }, (error) => {
      console.error("Error fetching user voices:", error);
    });

    return () => {
      unsubscribeBlogs();
      unsubscribeNewsletters();
      unsubscribeVoices();
      unsubscribeUserVoices();
    };
  }, []);

  const [highlightStyle, setHighlightStyle] = useState({});
  const navRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState("Being You");
  const [email, setEmail] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(1.0);
  const [isZooming, setIsZooming] = useState(false);


  const sections = [
    { id: "your-voice", label: "Your story", key: "story" },
    { id: "latest-articles", label: "Blogs", key: "blogs" },
    { id: "newsletter", label: "Newsletter", key: "newsletter" },
    { id: "wellness-journal", label: "Join Us", key: "join-us" }
  ];


  // Add these with your other useState declarations
  const [pdfWidth, setPdfWidth] = useState(790);
  const [touchStart, setTouchStart] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  // Add this useEffect after your other useEffects (around line 100-110)
  useEffect(() => {
    // Detect iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    setIsIOS(iOS);

    // Calculate PDF width based on screen
    const calculateWidth = () => {
      const width = window.innerWidth;
      if (width <= 640) {
        return width - 48; // Mobile: full width minus padding
      } else if (width <= 768) {
        return width - 100; // Tablet
      } else {
        return 790; // Desktop
      }
    };

    setPdfWidth(calculateWidth());

    const handleResize = () => setPdfWidth(calculateWidth());
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  // Add touch handlers for mobile swipe (add after your other functions)
  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    setTouchStart({ x: touch.clientX, y: touch.clientY });
  };

  const handleTouchEnd = (e) => {
    if (!touchStart) return;

    const touchEnd = e.changedTouches[0];
    const deltaX = touchEnd.clientX - touchStart.x;

    if (Math.abs(deltaX) > 50) {
      if (deltaX > 0 && pageNumber > 1) {
        setPageNumber(prev => prev - 1);
      } else if (deltaX < 0 && pageNumber < numPages) {
        setPageNumber(prev => prev + 1);
      }
    }

    setTouchStart(null);
  };
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!openNewsletter) return;

      if (e.key === 'ArrowLeft' && pageNumber > 1) {
        setPageNumber(prev => prev - 1);
      } else if (e.key === 'ArrowRight' && pageNumber < numPages) {
        setPageNumber(prev => prev + 1);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [openNewsletter, pageNumber, numPages]);

  // Add this useEffect to handle body scrolling when modal is open
  useEffect(() => {
    if (openNewsletter) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [openNewsletter]);

  useEffect(() => {
    const storySection = sections.find(s => s.key === 'story');

    if (storySection) {
      setActiveSection('story');

      const element = document.getElementById(storySection.id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);
  // 2. DATA (6 cards)
  const allArticlesStatic = [
    {
      id: 1,
      category: "Being You",
      title: " Alchemy of Growth: From Our Past to Our Future",
      date: "April 15, 2026",
      img: "/blogsimage/beingyoublog2_Header.png",
      secondaryImg: "/blogsimage/Beingofyoublog1_Embedded.png",
      author: " A blog by Meghna Warier",
      content: "By the end of a season, a forest floor is covered with the remains of what came before. As this happens, the roots get stronger, making the trees sturdy.\n\nLast season's storms taught resilience; its calm moments, patience. We don’t simply discard our history, we nourish (integrate) it. Every challenge and quiet moment of reflection from the previous chapter has been broken down into a beautiful budding flower that’s ready to bloom. By honoring what we’ve endured, we turn yesterday’s weight into the very energy required to sustain our next great reach toward the light.\n\nThis integration is what allows for a new beginning. There is vulnerability in the first sprout breaking through the surface. It’s new, it’s scary, it’s beautiful. It is a delicate balance of trembling uncertainty and a quiet, insistent excitement. We usually mistake the friction of a new phase for a sign to stop, but even the riverbed shifts when the water begins to flow again. Embrace the curiosity of the unknown.\n\nWe see change when we lean into fear and still take the first step and trust the process."

    },
    {
      id: 2,
      category: "Being You",
      title: "There’s Strength in the Unknown",
      date: "April 4, 2026",
      img: "/blogsimage/Beingyoublog1_Header.png",
      secondaryImg: "/blogsimage/Beingofyoublog2_Embedded.png",
      author: " A blog by Meghna Warier",
      content: "We often mistake the unknown for a threat, but it is really just an open space waiting for our arrival.\n\nCourage isn't about being fearless, it’s about choosing to move forward even when you're unsure. When we stop resisting the unfamiliar and start engaging with it, our anxiety transforms into momentum. With every brave step, the \"scary\" becomes the \"known,\" turning our deepest dread into the joy of discovery.\n\nThe most significant transformations usually happen in the quiet, messy \"in-between\" phases. While these phases can feel overwhelming or stagnant, they aren’t just waiting rooms—they are where our resilience is built. By existing in this middle ground without rushing, we give ourselves the time to settle into this new period. This flow isn't a disruption but the foundation of your deepest, most enduring strength\n\nRemember the butterfly and its transformation; the struggle within the cocoon is exactly what prepares it for the flight ahead."

    },
    {
      id: 3,
      category: "Being You",
      title: "Out of the Cocoon",
      date: "march 20 , 2026",
      img: "/blogsimage/Beingyoublogapril_Header.png",
      secondaryImg: "/blogsimage/Beingyoublogapril_embedded.png",
      author: " A blog by Meghna S Warrier",
      content: "The cocoon – the first home – was safe, but it was never meant to be your permanent home.It was your safe space to rest, rest, and grow out of it. Coming out of your comfort zone can feel exposed and strange, but it is the only way to discover your wings. A whole new life is waiting for you on the other side of that struggle. Yet there's beauty in looking back and seeing how far you've come.\n\nTrust the transformation; you are finally ready to see the world from a higher perspective."

    },

    {
      id: 4,
      category: "Spring of You",
      title: "The Reminders of Spring ",
      date: "March 28, 2026",
      img: "/blogsimage/springofyoublog1_Header.png",

      secondaryImg: "/blogsimage/springofyoublog1_Embedded.png",
      author: " A blog by Aanya Pande",
      content: "I like to think of spring as a season full of reminders—of harvest, growth, and possibilities bursting forth.\n\nI notice how spring begins with the last traces of winter slowly fading away. Flowers can’t wait to bloom when the cold has only just lifted, and trees hold onto bare branches a little longer. Yet even in that stillness, there is quiet patience. A reminder of hope, especially in the quieter moments.\n\nI’m fascinated by how the season unfolds, flowers beginning to bloom—gradually and at their own pace. No two blossoms emerge at the same time, yet each is beautiful in its own way. Some years the smallest flowers appear first; other times, larger blossoms signal the arrival of spring. A reminder that growth can be subtle or striking, quiet or unmistakable.\n\nI love how at the height of spring, the world seems almost to dance. Butterflies drift from flower to flower, bees hum among blossoms, and warm evenings linger in soft air. There is a gentle happiness woven through the days. A remembrance of our joy and care, so that even ordinary moments feel warm.\n\nIt’s easy to miss how, as spring begins to fade, colors slowly shift. Fresh green leaves prepare to deepen and change, slowly moving toward the hues of another season. A reminder to look back on each version of ourselves with care, not regret.\n\nFrom beginning to end, spring is filled with quiet reminders of joy.Maybe today, you’ll notice some of your own."


    },
    {
      id: 5,
      category: "Spring of You",
      title: "Each of Us Are Meadows ",
      date: "March 20, 2026",
      img: "/blogsimage/springofyoublog2_Header.png",
      secondaryImg: "/blogsimage/springofyoublog2_Embedded.png",
      author: " A blog by Aanya Pande",
      content: "Gardens are carefully cultivated—gentle blooms of color arranged in ways we believe to be perfect. Yet meadows hold a different kind of wonder: diverse and untamed, where small wildflowers scatter among larger blossoms. Often, we feel compelled to become gardens ourselves—controlled, restrained, and deliberate. But what is easy to miss is that our true beauty lies in the meadows we already are: unfiltered, expansive, and alive with the quiet harmony of spring.\n\nWhen we embrace natural beauty without questioning its design or pace, we begin to see it in its truest light. The same is true for ourselves. Constant judgment, doubt, and scrutiny rarely lead to discovery; more often, they create unnecessary strain. When we force ourselves into rigid definitions, we lose the ability to remember our true light and nature.\n\nSo the next time you find yourself caught in cycles of self-questioning or doubt, pause for a moment and breathe. Gardens are beautiful—but you are far vaster than that. Each of us is more like a meadow, filled with complexity, wonder, and quiet uncertainty. And it is only when we step back that we can truly appreciate it.\n\nTake a moment today to step back—and wonder at yourself."
    },
    {
      id: 6,
      category: "Spring of You",
      title: "Giving Space to Bloom ",
      date: "april 20, 2026",
      img: "/blogsimage/springofyou3_header.jpg",

      secondaryImg: "/blogsimage/springofyou3_embedded.jpg",
      author: " A blog by  Meghna S Warrier",
      content: "Allow yourself to bloom without the shadow of guilt. Often, we hesitate to embrace happiness because we are unconsciously mourning the familiar comfort of the past, fearing that our best days are now behind us. But you do not have to grieve for what is gone in order to enjoy the sun today.\n\nJust as a flower doesn't apologize for taking up space, you must give yourself the space to flourish. Stepping into the unknown is inherently uncomfortable, but that friction is simply the soil making room for your growth. The future is bright, and it belongs to those brave enough to grow."


    },

    {
      id: 7,
      category: "Spring of You",
      title: "The First Blooms",
      date: "April 27 , 2026",
      img: "/blogsimage/SpringofyouAprilBlogembedded.jpg",

      secondaryImg: "/blogsimage/AprilBlogImageHeader.jpg",
      author: " A blog by Aanya Pande",
      content: "The first blooms are subtle, hopeful, and filled with the understanding that the greatest novelties of all come from within. Like fairies dancing across a meadow or quiet gleams of colorful light, they seem to carry a little bit of magic as they grow. But their magic doesn’t come from their sprouting, or even the very petals that give them the color we so admire—it comes from the way we look at them.\n\nThe awe, admiration, and care we show to a blooming flower or a little bud are what help us see them as magical. And sometimes, we deserve that awe from ourselves too. Today, take a step back to appreciate—and admire—how far you have come. Remember a moment from a little while ago, and compare the person you were to the person you are today. See how much you’ve grown?\n\nSometimes our own growth is the most colorful of all—it’s just a little harder to notice."


    },
    {
      id: 8,
      category: "Spring of You",
      title: "Surrounding Yourself With Joy",
      date: "May  5 , 2026  ",
      img: "/blogsimage/MayBlogEmbedded.jpg",

      secondaryImg: "/blogsimage/MayBlogHeader.jpg",
      author: " A blog by Aanya Pande",
      content: "Where we are influences who we are. It’s a simple idea, really, but one that can truly change the way we place ourselves in the world around us. Everything we see becomes a part of the experiences that shape us: and more often than not, it’s the beauty that surrounds us that leaves the quietest, yet most striking impact.\n\nThere is a joy in knowing that we too influence what surrounds us. Like flowers in a garden, the color that surrounds us brings joy — and we bring color to someone else’s garden in turn. Everything is a cycle, in its own beautiful way, and discovering the joy within us makes it even easier to see the joy outside.\n\nTake a second to look around and notice everything around you now. Hear the birds chirp, see a little flower on your windowsill, and be reminded that there is always more joy out there than we notice at first glance."


    },
    {
      id: 9,
      category: "Spring of You",
      title: "Introducing Ourselves to Growth ",
      date: "May  12 , 2026  ",
      img: "/blogsimage/blogmayphoto.jpg",

      secondaryImg: "/blogsimage/mayblogembedded121.png",
      author: " A blog by Aanya Pande",
      content: "Just as we meet new people, we also meet new versions of ourselves as time passes. Each version is still undeniably us, yet carries its own unique bloom — a habit, a conversation, a hobby, or a newfound interest. More often than not, we forget to acknowledge these quiet transformations. Yet, with time, we come to realize that they are what make us “us”.\n\nWhy? Because we are not meant to remain static. Human beings are meant to grow, to bloom, to experiment. When we confine ourselves to who we are today, we overlook all the possibilities tomorrow may hold. In growth, we discover.\n\nThis month, make a promise to yourself: watch yourself grow. Introduce yourself to every version of who you are becoming. Slowly peel back the layers and allow your truest self to emerge. Then, change will no longer feel like a surprise, but like a quiet unfolding."


    },
    {
      id: 10,
      category: "Being You",
      title: "The Perfect Time To Step Out",
      date: "may 19, 2026",
      img: "/blogsimage/headermay19blogedit.jpeg",
      secondaryImg: "/blogsimage/embeddedmay19blog.jpeg",
      author: " A blog by Meghna S Warrier",
      content: "There’s a voice in our head that says, “Go, everything you want is waiting for you on the other side.”\n\nWhen the world around us is in full motion, our own hesitation begins to dissolve. Stepping out of your comfort zone doesn't feel like a chore right now, but an invitation. When you create an environment that is boldly asserting itself, you realize that everything is possible. When your heart and mind align with the endless sea of growth, the path forward becomes an inspiring playground instead of an intimidating climb."

    },
    {
      id: 11,
      category: "Spring of You",
      title: "Finding Beauty in the Little Things",
      date: "May 26, 2026  ",
      img: "/blogsimage/headermay26blog.jpeg",

      secondaryImg: "/blogsimage/embedded26may.jpeg",
      author: " A blog by Aanya Pande",
      content: "Have you ever noticed how the most powerful moments are often the smallest? We don’t remember entire months, weeks, or even days at a time: we remember mere seconds that somehow shifted our perspective in ways more profound than anything else..\n\nEven the gentlest shifts in life leave an impact, reminding us that change doesn’t need to be loud to be meaningful.  A moment of reflection unravels a pattern of growth, just as a single flower brightens an otherwise simple meadow. A passing thought can be the spark that lights up a larger idea; a smile from a stranger might be just what brightens your entire day\n\nIf there’s anything to learn from the little things, it’s to find joy in the ordinary. To embrace the normative, to find thrill in the arbitrary. Anyone can find beauty in the ephemeral, fleeting, and precious: it takes a special eye to find it in the unremarkable. Today, look around for the smallest of things — the ones you would otherwise glaze over. You never know what you might be missing."


    },
    {
      id: 12,
      category: "Summer of You",
      title: "Summer Rain",
      date: "mjune 03 , 2026",
      img: "/blogsimage/headerjune03blog.jpeg",
      secondaryImg: "/blogsimage/embeddedjune03blog.jpeg",
      author: " A blog by Aanya Pande",
      content: "Rain isn’t necessarily gloomy: it’s often much more. When we reduce the rains to just gloom, we lose their quiet beauty: the gentle pitter-patter of rain reminding us to notice the little things, the feeling of a soft drizzle gently refreshing us on a hot day, and the momentary awareness of carrying an umbrella, checking the weather, and making plans that work with nature, not despite it and the beauty of the sun shining through the droplets of rain reflecting the brilliance of colors in one single droplet\nNext time it’s raining, stop to notice. Don’t just tolerate rain: embrace it."

    },
  ];

  const allArticles = [...allArticlesStatic, ...dynamicBlogs];

  const staticNewsletters = [
    { id: 'static-may', title: 'May', pdfUrl: '/Nabi UI Assets/monthlynewsletter/maynewsletter.pdf' },
    { id: 'static-april', title: 'April', pdfUrl: '/Nabi UI Assets/monthlynewsletter/AprilFinalDraft.pdf' },
    { id: 'static-march', title: 'March', pdfUrl: '/Nabi UI Assets/monthlynewsletter/MarchNoBorders.pdf' }
  ];
  const allNewsletters = [...staticNewsletters, ...dynamicNewsletters];

  // Update document title for link previews based on the open newsletter
  useEffect(() => {
    if (openNewsletter) {
      // Find the actual title based on the slug or url
      const matched = allNewsletters.find(n => 
        (n.title && n.title.toLowerCase().replace(/[^a-z0-9]+/g, '-') === openNewsletter) || 
        n.pdfUrl === openNewsletter ||
        n.id === openNewsletter
      );
      
      // We capitalize the string and add "Newsletter"
      const titleToDisplay = matched && matched.title 
        ? matched.title 
        : openNewsletter.replace(/-/g, ' ');
        
      document.title = `Nabi - ${titleToDisplay.charAt(0).toUpperCase() + titleToDisplay.slice(1)} Newsletter`;
    } else {
      document.title = "Nabi World"; // Reset to default when closed
    }
  }, [openNewsletter, allNewsletters]);

  const getPdfUrl = (val) => {
    if (!val) return null;
    if (val === 'may') return '/Nabi UI Assets/monthlynewsletter/maynewsletter.pdf';
    if (val === 'april') return '/Nabi UI Assets/monthlynewsletter/AprilFinalDraft.pdf';
    if (val === 'march') return '/Nabi UI Assets/monthlynewsletter/MarchNoBorders.pdf';
    
    const matched = allNewsletters.find(n => 
      (n.title && n.title.toLowerCase().replace(/[^a-z0-9]+/g, '-') === val) || 
      n.pdfUrl === val
    );
    return matched ? matched.pdfUrl : val;
  };

  useEffect(() => {
    const articleId = parseInt(searchParams.get('article'), 10);
    if (articleId && allArticles.length > 0) {
      const article = allArticles.find(a => a.id === articleId);
      if (article) {
        setSelectedArticleState(article);
        setblogOpenState(true);
      }
    }
  }, [searchParams, dynamicBlogs]);

  const activeItemType = blogopen ? "blog" : (openNewsletter ? "newsletter" : null);
  const activeItemId = blogopen && selectedArticle ? selectedArticle.id.toString() : (openNewsletter ? openNewsletter : null);
  const interactionCollection = activeItemType === "blog" ? "blog_interactions" : "newsletter_interactions";

  // Fetch Likes and Comments when an article or newsletter is opened
  useEffect(() => {
    if (!activeItemType || !activeItemId) return;

    const interactionRef = doc(db, interactionCollection, activeItemId);
    const commentsRef = collection(db, interactionCollection, activeItemId, "comments");
    
    const unsubscribeLikes = onSnapshot(interactionRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setLikesCount(data.likesCount || 0);
        setLikedByUIDs(data.likedBy || []);
        if (auth.currentUser && data.likedBy && data.likedBy.includes(auth.currentUser.uid)) {
          setIsLiked(true);
        } else {
          setIsLiked(false);
        }
      } else {
        setLikesCount(0);
        setLikedByUIDs([]);
        setIsLiked(false);
      }
    });

    const commentsQuery = query(commentsRef, orderBy("createdAt", "desc"));
    const unsubscribeComments = onSnapshot(commentsQuery, (snapshot) => {
      const fetchedComments = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setComments(fetchedComments);
    }, (error) => {
      console.error("Error fetching comments: ", error);
    });

    return () => {
      unsubscribeLikes();
      unsubscribeComments();
    };
  }, [activeItemType, activeItemId, interactionCollection, auth.currentUser]);

  useEffect(() => {
    if (!isLikesModalOpen || likedByUIDs.length === 0) return;
    
    const fetchLikedUsers = async () => {
      try {
        const userPromises = likedByUIDs.map(uid => 
          getDocs(query(collection(db, "users"), where("uid", "==", uid)))
        );
        const results = await Promise.all(userPromises);
        const fetchedUsers = results.map((snapshot, index) => {
           if (!snapshot.empty) {
             const data = snapshot.docs[0].data();
             return { 
               uid: likedByUIDs[index], 
               name: data.displayName || data.firstName || data.name || "Anonymous User",
               photoURL: data.photoURL || null
             };
           }
           return { uid: likedByUIDs[index], name: "Anonymous User", photoURL: null };
        });
        setLikedUsersDetails(fetchedUsers);
      } catch (err) {
        console.error("Failed to fetch liked users:", err);
      }
    };
    fetchLikedUsers();
  }, [isLikesModalOpen, likedByUIDs]);

  const handleLike = async () => {
    if (!auth.currentUser) {
      if (setIsLoginOpen) {
        setIsLoginOpen(true);
      } else {
        message.warning(`Please log in to like this ${activeItemType || "item"}.`);
      }
      return;
    }

    if (!activeItemId) return;
    const interactionRef = doc(db, interactionCollection, activeItemId);

    try {
      const docSnap = await getDoc(interactionRef);
      const userName = auth.currentUser.displayName || auth.currentUser.email || "Anonymous User";

      if (!docSnap.exists()) {
        await setDoc(interactionRef, {
          likesCount: 1,
          likedBy: [auth.currentUser.uid],
          likedByUsers: [{ uid: auth.currentUser.uid, name: userName }]
        });
      } else {
        if (isLiked) {
          await updateDoc(interactionRef, {
            likesCount: Math.max(0, likesCount - 1),
            likedBy: arrayRemove(auth.currentUser.uid),
            likedByUsers: arrayRemove({
              uid: auth.currentUser.uid,
              name: userName
            })
          });
        } else {
          await updateDoc(interactionRef, {
            likesCount: likesCount + 1,
            likedBy: arrayUnion(auth.currentUser.uid),
            likedByUsers: arrayUnion({
              uid: auth.currentUser.uid,
              name: userName
            })
          });
        }
      }
    } catch (error) {
      console.error("Error updating like:", error);
      message.error("Failed to update like.");
    }
  };

  const handleAddComment = async () => {
    if (!auth.currentUser) {
      if (setIsLoginOpen) {
        setIsLoginOpen(true);
      } else {
        message.warning("Please log in to add a comment.");
      }
      return;
    }

    if (!newComment.trim()) return;

    if (!activeItemId) return;
    const commentsRef = collection(db, interactionCollection, activeItemId, "comments");
    const interactionRef = doc(db, interactionCollection, activeItemId);

    try {
      // Ensure the parent document exists
      const docSnap = await getDoc(interactionRef);
      if (!docSnap.exists()) {
        await setDoc(interactionRef, { likesCount: 0, likedBy: [] });
      }

      let userName = auth.currentUser.displayName;
      if (!userName) {
        const userQ = query(collection(db, "users"), where("uid", "==", auth.currentUser.uid));
        const userSnap = await getDocs(userQ);
        if (!userSnap.empty) {
          const userData = userSnap.docs[0].data();
          userName = userData.displayName || userData.firstName || userData.name;
        }
      }
      userName = userName || auth.currentUser.email || "Anonymous User";

      await addDoc(commentsRef, {
        text: newComment.trim(),
        userId: auth.currentUser.uid,
        userName: userName,
        createdAt: serverTimestamp()
      });
      setNewComment("");
    } catch (error) {
      console.error("Error adding comment:", error);
      message.error("Failed to post comment.");
    }
  };

  // 3. FILTER & SORT LOGIC
  const parseDate = (dateStr) => {
    if (!dateStr) return new Date(0);
    // Clean up extra spaces
    const cleaned = dateStr.replace(/\s+/g, ' ').trim();
    const d = new Date(cleaned);
    return isNaN(d.getTime()) ? new Date(0) : d;
  };

  const filteredArticles = allArticles
    .filter(item => item.category === activeCategory)
    .sort((a, b) => parseDate(b.date) - parseDate(a.date));

  const categories = ["Being You", "Spring of You", "Summer of You", "Autumn of You", "Winter of You"];

  const handleSubscribe = () => {
    if (!email.trim()) {
      alert("Please enter a valid email address before subscribing.");
      return;
    }
    alert(`Thank you for joining! We've sent a confirmation to ${email}`);
    setEmail(''); // Clear field after success
  };

  const handleNavClick = (id, key) => {
    setActiveSection(key);
    const element = document.getElementById(id);
    if (element) {
      const offset = 145;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    if (navRef.current) {
      const activeItem = navRef.current.querySelector('.nav-item-active');
      if (activeItem) {
        setHighlightStyle({
          left: activeItem.offsetLeft,
          width: activeItem.offsetWidth,
        });
      }
    }
  }, [activeSection]);

  useEffect(() => {
    if (openNewsletter || blogopen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [openNewsletter, blogopen]);



  const checkLoginForShare = (e) => {
    if (!auth.currentUser) {
      e.preventDefault();
      e.stopPropagation();
      if (setIsLoginOpen) {
        setIsLoginOpen(true);
      } else {
        message.warning("Please log in to share.");
      }
      return false;
    }
    return true;
  };

  const renderInteractionBar = (isNewsletter = false) => (
    <div className="blog-interactions-bar" style={isNewsletter ? {
      position: 'fixed',
      bottom: '40px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '16px 32px',
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderRadius: '100px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      border: '1px solid rgba(255,255,255,0.4)',
      display: 'flex', 
      gap: '32px', 
      alignItems: 'center',
      zIndex: 1000,
    } : { 
      marginTop: '40px', 
      marginBottom: '0px',
      paddingTop: '20px',
      paddingBottom: '0px',
      borderTop: '1px solid #eaeaea', 
      background: 'transparent',
      borderRadius: '0',
      boxShadow: 'none',
      width: 'auto',
      maxWidth: '100%',
      justifyContent: 'flex-start',
      display: 'flex', gap: '24px', alignItems: 'center' 
    }}>
      <Tooltip title="Likes" placement="top" color="#003047" zIndex={999999}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div 
            className="blog-like-icon" 
            onClick={handleLike}
            style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill={isLiked ? "#FF9F7C" : "none"} stroke={isLiked ? "#FF9F7C" : "#666"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </div>
          <span 
            onClick={() => setIsLikesModalOpen(true)}
            style={{ fontSize: '15px', color: '#666', cursor: likesCount > 0 ? 'pointer' : 'default' }}
          >
            {likesCount}
          </span>
        </div>
      </Tooltip>

      <Tooltip title="Comments" placement="top" color="#003048" zIndex={999999}>
        <div 
          className="blog-comment-button"
          onClick={() => setIsCommentsOpen(true)}
          style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          <span style={{ fontSize: '15px', color: '#666' }}>{comments.length}</span>
        </div>
      </Tooltip>

      <Tooltip title="Share" placement="top" color="#003048" zIndex={999999}>
        <Dropdown 
          menu={{ 
            items: [
              {
                key: '1',
                label: (
                  <a target="_blank" rel="noopener noreferrer" href="#" onClick={(e) => {
                    if (!checkLoginForShare(e)) return;
                    e.preventDefault();
                    const titleText = activeItemType === 'blog' ? selectedArticle?.title : openNewsletter;
                    const shareText = `*${titleText || 'Nabi Post'}*\n\nRead more here:\n${window.location.href}`;
                    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, '_blank');
                  }} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#003049' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                    WhatsApp
                  </a>
                ),
              },
              {
                key: '2',
                label: (
                  <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/direct/inbox/" onClick={(e) => {
                    if (!checkLoginForShare(e)) return;
                    const titleText = activeItemType === 'blog' ? selectedArticle?.title : openNewsletter;
                    const shareText = `*${titleText || 'Nabi Post'}*\n\nRead more here:\n${window.location.href}`;
                    navigator.clipboard.writeText(shareText);
                    message.success("Copied to clipboard! Please PASTE (Ctrl+V) it in the Instagram chat.", 6);
                  }} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#003049' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                    Instagram
                  </a>
                ),
              },
              {
                key: '3',
                label: (
                  <a target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`} onClick={(e) => {
                    if (!checkLoginForShare(e)) return;
                  }} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#003049' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                    LinkedIn
                  </a>
                ),
              },
              {
                key: '4',
                label: (
                  <div onClick={(e) => {
                    if (!checkLoginForShare(e)) return;
                    navigator.clipboard.writeText(window.location.href);
                    message.success("Link copied to clipboard!");
                  }} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#003049' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
                    Copy Link
                  </div>
                ),
              },
            ] 
          }} 
          trigger={['click']} 
          placement="topRight" 
          getPopupContainer={() => document.body}
          overlayStyle={{ zIndex: 999999 }}
        >
          <div 
            className="blog-share-button"
            onClick={(e) => {
              if (!checkLoginForShare(e)) return;
            }}
            style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
              <polyline points="16 6 12 2 8 6"></polyline>
              <line x1="12" y1="2" x2="12" y2="15"></line>
            </svg>
          </div>
        </Dropdown>
      </Tooltip>
    </div>
  );

  return (



    // <div style={styles.container}>

    <div className="blogs-page-wrapper" style={{ position: 'relative' }}>
      {!blogopen && !openNewsletter && (
        <nav className="blog-nav">
          <div className="nav-container">
            <div className="pill-wrapper" ref={navRef}>
              {/* This is the sliding highlight background */}
              <div style={{ ...highlightStyle, position: 'absolute', top: '5px', bottom: '5px', background: 'linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 100%)', borderRadius: '40px', transition: 'all 0.3s ease' }} />

              {sections.map((section) => (
                <span
                  key={section.key}
                  onClick={() => handleNavClick(section.id, section.key)}
                  className={activeSection === section.key ? "nav-item nav-item-active" : "nav-item"}
                >
                  {section.label}
                </span>
              ))}
            </div>

            <div className="nav-icons">
            </div>
          </div>
        </nav>
      )}

      {/* Your Voice carousel section */}
      <div id="your-voice" className="section-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '60px 20px', position: 'relative' }}>
        <button 
          onClick={() => setIsShareModalOpen(true)}
          className="share-story-btn"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
          Share Your Story
        </button>
        <div className="story-header-flex">
          <div className="story-header-left">
            <div className="story-header-subtitle">
              Real Stories &middot; Real Journeys &middot; Real Transformation
            </div>
            <h2 className="story-header-title">
              Stories that remind us<br/>
              <span style={{ color: '#D97B58' }}>we are</span> not alone.
            </h2>
          </div>
          <div className="story-header-right">
            <p className="story-header-desc">
              Stories of resilience,hope and love shared by ordinary people living extraordinary lives.
            </p>
          </div>
        </div>
        
        <VoiceCarousel voices={dynamicVoices} onVoiceClick={handleVoiceClick} />
      </div>

      {/* Latest articles */}


      <div id="latest-articles" className="section-container">
        {/* HEADER SECTION */}
        <div className="header-row">
          <h2 className="blogs-title">Nabi Blogs</h2>

        </div>
        <p className="blogs-description">
          Stories for every season of your soul - A reminder to come home to yourself and nature.</p>

        {/* FILTER TABS */}
        <div className="top-bar">
          <div className="filter-row">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className="tab"
                style={{
                  backgroundColor: activeCategory === cat ? '#FF9F7C' : '#fff',
                  color: activeCategory === cat ? '#fff' : '#666',
                  border: activeCategory === cat ? '1px solid #FF9F7C' : '1px solid #eee',
                }}
              >
                {cat}
              </button>
            ))}


            {/* <div style={styles.controlsRight}>
              <div
                onMouseEnter={() => setHoverSearch(true)}
                onMouseLeave={() => setHoverSearch(false)}
                style={{
                  ...styles.iconCircle,
                  backgroundColor: hoverSearch ? '#fff' : 'transparent',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2.5">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
              
              <div
                onMouseEnter={() => setHoverSort(true)}
                onMouseLeave={() => setHoverSort(false)}
                style={{
                  ...styles.sortDropdown,
                  backgroundColor: hoverSort ? '#fff' : 'transparent',
                }}
              >
                Sort by
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="3" style={{ marginLeft: '8px' }}>
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div> */}
          </div>

          {/* ARTICLES GRID */}

          <>
            {/* 1. The Main Blog Grid */}
            <div className="grid">
              {filteredArticles.length > 0 ? (
                filteredArticles.map((article) => (
                  <div
                    key={article.id}
                    className="blog-card"
                    /* Triggers both the specific data and the visibility state */
                    onClick={() => {
                      setSelectedArticle(article);
                      setblogOpen(true);
                    }}
                  >
                    <div className="image-wrapper">
                      <img src={article.img} className="card-image" alt={article.title} />
                    </div>
                    <div className="card-category">{article.category}</div>
                    <h3 className="card-title">{article.title}</h3>
                    {/* Date hidden as per user request */}
                  </div>
                ))
              ) : (
                <div className="empty-message">
                  Wait for the {activeCategory.split(' ')[0].toLowerCase()} to arrive...
                </div>
              )}
            </div>

            {/* 2. The Full-Screen Blog Overlay */}
            {blogopen && selectedArticle && (
              <div className="blog-overlay blog-scroll-container">

                {/* Close Button */}
                <button 
                  className="blog-close-btn" 
                  onClick={() => setblogOpen(false)}
                  style={{ display: (isCommentsOpen || isLikesModalOpen) ? 'none' : 'flex' }}
                >
                  ✕
                </button>

                <div className="blog-article-wrapper">

                  {/* Header Image (Dynamic from selectedArticle) */}
                  <div className="blog-hero-image-container">
                    <img
                      src={selectedArticle.img}
                      className="blog-hero-image"
                      alt={selectedArticle.title}
                    />
                  </div>

                  <div className="blog-content-area">
                    {/* Dynamic Category & Title */}
                    <div className="blog-badge">{selectedArticle.category}</div>
                    <h1 className="blog-heading">{selectedArticle.title}</h1>

                    <div className="blog-body-grid">

                      {/* Left Side: Dynamic Text Data */}
                      <div className="blog-text-column">
                        <p className="blog-author-name">
                          {selectedArticle.author}
                        </p>
                        <div className="blog-main-text">
                          {selectedArticle.content || "Content Coming Soon..."}
                        </div>
                      </div>

                      {/* Right Side: Dynamic Embedded Image */}
                      <div className="blog-image-column">
                        {selectedArticle.secondaryImg && (
                          <img
                            src={selectedArticle.secondaryImg}
                            className="blog-detail-image"
                            alt="Detail visual"
                          />
                        )}
                      </div>

                    </div>

                    {/* Interactions Section */}
                    {renderInteractionBar(false)}
                  </div>

                  {/* Spacer to allow scrolling to the very bottom */}
                  <div style={{ height: '80px', width: '100%' }}></div>
                </div>
              </div>
            )}
            <>
                {/* Right Sidebar for Comments */}
                <div style={{
                  position: 'fixed',
                  top: 0,
                  right: isCommentsOpen ? 0 : '-400px',
                  width: '400px',
                  maxWidth: '100%',
                  height: '100%',
                  backgroundColor: '#fff',
                  boxShadow: '-4px 0 15px rgba(0,0,0,0.1)',
                  zIndex: 2000,
                  transition: 'right 0.3s ease-in-out',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ padding: '24px', borderBottom: '1px solid #eaeaea', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ color:'#003049',margin: 0, fontSize: '16px', fontFamily: 'sans-serif', fontWeight: 'bold' }}>Responses ({comments.length})</h3>
                    <button onClick={() => setIsCommentsOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#666' }}>✕</button>
                  </div>
                  
                  <div style={{ padding: '24px', flex: 1, overflowY: 'auto' }}>
                    {/* Input box */}
                    <div style={{ padding: '16px', borderRadius: '12px', border: '1px solid #ddd', marginBottom: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                      <textarea
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        placeholder="What are your thoughts?"
                        style={{
                          width: '100%',
                          border: 'none',
                          outline: 'none',
                          resize: 'none',
                          minHeight: '60px',
                          fontFamily: 'sans-serif',
                          fontSize: '15px'
                        }}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                        <button
                          onClick={() => {
                            handleAddComment();
                          }}
                          disabled={!newComment.trim()}
                          style={{
                            padding: '8px 16px',
                            borderRadius: '20px',
                            border: 'none',
                            backgroundColor: newComment.trim() ? '#FF9F7C' : '#eee',
                            color: newComment.trim() ? '#fff' : '#aaa',
                            cursor: newComment.trim() ? 'pointer' : 'not-allowed',
                            fontWeight: 'bold',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          Post
                        </button>
                      </div>
                    </div>

                    {/* Comments List */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                      {comments.map(comment => (
                        <div key={comment.id} style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#FF9F7C', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', marginRight: '12px', fontSize: '14px' }}>
                              {comment.userName.charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div style={{ fontWeight: 600, fontSize: '14px', color: '#003049' }}>{comment.userName}</div>
                              <div style={{ fontSize: '12px', color: '#003047' }}>
                                {comment.createdAt ? new Date(comment.createdAt.toMillis()).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : 'Just now'}
                              </div>
                            </div>
                          </div>
                          <p style={{ margin: 0, fontSize: '15px', color: '#003049', lineHeight: '1.5' }}>{comment.text}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Overlay background when comments or likes open */}
                {(isCommentsOpen || isLikesModalOpen) && (
                  <div 
                    onClick={() => {
                      setIsCommentsOpen(false);
                      setIsLikesModalOpen(false);
                    }}
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 1999 }}
                  />
                )}

                {/* Right Sidebar for Likes */}
                <div style={{
                  position: 'fixed',
                  top: 0,
                  right: isLikesModalOpen ? 0 : '-400px',
                  width: '400px',
                  maxWidth: '100%',
                  height: '100%',
                  backgroundColor: '#fff',
                  boxShadow: '-4px 0 15px rgba(0,0,0,0.1)',
                  zIndex: 2000,
                  transition: 'right 0.3s ease-in-out',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ padding: '24px', borderBottom: '1px solid #eaeaea', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ color:'#003049',margin: 0, fontSize: '16px', fontFamily: 'sans-serif', fontWeight: 'bold' }}>Likes ({likesCount})</h3>
                    <button onClick={() => setIsLikesModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#003049' }}>✕</button>
                  </div>
                  
                  <div style={{ padding: '24px', flex: 1, overflowY: 'auto' }}>
                    {likedUsersDetails.length > 0 ? (
                      likedUsersDetails.map((user, idx) => (
                        <div key={user.uid || idx} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                          <div style={{ position: 'relative', marginRight: '16px' }}>
                            {user.photoURL ? (
                              <img src={user.photoURL} alt={user.name} style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover' }} />
                            ) : (
                              <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: '#f0f0f0', color: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '18px' }}>
                                {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                              </div>
                            )}
                            <div style={{ 
                              position: 'absolute', bottom: '-2px', right: '-2px', 
                              backgroundColor: '#fff', borderRadius: '50%', padding: '2px',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}>
                              <div style={{ 
                                backgroundColor: '#FF9F7C', width: '18px', height: '18px', 
                                borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' 
                              }}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="#fff" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div style={{ fontWeight: 600, color: '#003049', fontSize: '15px' }}>{user.name}</div>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', color: '#888', padding: '20px 0' }}>No likes yet.</div>
                    )}
                  </div>
                </div>
            </>
          </>
        </div>
      </div>

      <div className="wellness-card"> 

        {/* newsletter section */}
        <div id="newsletter" className="content-area">
          <h1 className="journal-title">
            Nabi Newsletter
          </h1>
          <p className="description">
            Pieces of each season, to carry with you each month. Every newsletter is a reminder written just for you.
          </p>
          <div className="newsletter-buttons">
            {allNewsletters.map(n => (
              <button
                key={n.id}
                onClick={() => {
                  const slug = n.title ? n.title.toLowerCase().replace(/[^a-z0-9]+/g, '-') : n.pdfUrl;
                  setOpenNewsletter(slug);
                }}
                className="pdf-button"
              >
                {n.title}
              </button>
            ))}
          </div>
          {/* Ant Design Modal with react-pdf for crystal-clear, cross-browser viewing */}

          <Modal
            open={!!openNewsletter}
            onCancel={() => {
              setOpenNewsletter(null);
              setPageNumber(1);
              setNumPages(null);
            }}
            footer={null}
            width="100%"
            centered={false}
            destroyOnClose
            className="premium-pdf-modal"
            closable={true}
            closeIcon={
              <span style={{
                fontSize: '20px',
                fontWeight: 'bold',
                display: 'block',
                lineHeight: 1
              }}>✕</span>
            }
            style={{
              top: 0,
              padding: 0,
              margin: 0,
              maxWidth: '100%'
            }}
            styles={{
              body: {
                padding: 0,
                overflowY: 'auto',
                background: '#f0f2f5',
                height: '100dvh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                marginTop: 0,
                WebkitOverflowScrolling: 'touch'
              },
              content: {
                borderRadius: 0,
                margin: 0,
                padding: 0,
                position: 'relative',
                overflow: 'hidden',
                height: '100dvh'
              },
              mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(0,0,0,0.9)'
              },
              wrapper: {
                top: 0,
                paddingBottom: 0
              }
            }}
          >
            <div
              className="pdf-clipper"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                background: 'linear-gradient(185deg, #FFDFB9 0%, #FFF5EE 50%, #FFDFB9 100%)',
                padding: window.innerWidth <= 768 ? '40px 0 20px 0' : '70px 20px 20px 20px',
                overflowY: 'auto',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'touch',
              }}
              ref={(el) => {
                if (el) {
                  el.scrollTop = 0;
                }
              }}
            >
              <Document
                file={getPdfUrl(openNewsletter)}
                onLoadSuccess={({ numPages }) => {
                  setNumPages(numPages);
                  setTimeout(() => {
                    const container = document.querySelector('.pdf-clipper');
                    if (container) container.scrollTop = 0;
                  }, 100);
                }}
                onLoadError={(error) => console.error("PDF Load Error:", error)}
                loading={
                  <div style={{ padding: '50px', textAlign: 'center' }}>
                    <div className="loading-spinner"></div>
                    <p style={{ marginTop: '10px' }}>Loading Newsletter...</p>
                  </div>
                }
                error={<div style={{ padding: '50px', textAlign: 'center', color: '#cf1322' }}>Failed to load PDF. Please try again.</div>}
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                  gap: '16px'
                }}>
                  {numPages && Array.from(new Array(numPages), (el, index) => (
                    <div
                      key={index + 1}
                      style={{
                        marginBottom: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%'
                      }}
                    >
                      <Page
                        pageNumber={index + 1}
                        width={pdfWidth}
                        renderMode="svg"
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                        className="pdf-page-shadow"
                        loading={<div style={{ height: '500px', background: '#fff', width: pdfWidth }}></div>}
                      />
                    </div>
                  ))}
                  
                  {numPages && (
                    <>
                      <div style={{ height: '80px', width: '100%' }}></div>
                      {renderInteractionBar(true)}
                    </>
                  )}
                </div>
              </Document>
            </div>
          </Modal>
        </div>

        {/* RIGHT SIDE: IMAGE */}
        <div className="image-container">
          <img
            src="/newlettersectionimg.jpeg"
            alt="Wellness Journal"
            className="journal-image"
          />
        </div>

      </div>

      {/* community join section  */}
      <div id="wellness-journal" className="newsletter-section">
        <h2 style={{ marginBottom: 0, marginTop: "0.5%" }} className="community-title"> Join our world of nabi community </h2>


        <p style={{ marginTop: "6px" }} className="community-subtitle">
          To be connected, receive and share insights.
        </p>





        <div>
          <img
            src="/nabiwhatsappqrcode.jpeg" // Replace with your actual QR image path
            alt="Join WhatsApp Community"
            className="qr-image"
          />
        </div>
      </div>



      {/* Share Modal */}
      {isShareModalOpen && (
        <div className="voice-story-modal-overlay">
          <div className="voice-story-modal">
            <button className="voice-story-modal-close" onClick={() => { setIsShareModalOpen(false); setModalStep(1); }}>✕</button>
            
            {modalStep === 1 ? (
              <>
                <div className="voice-story-modal-progress">
                  <div className="voice-story-modal-progress-filled"></div>
                  <div className="voice-story-modal-progress-empty"></div>
                </div>

                <p className="voice-story-modal-step">STEP 1 OF 2</p>
                <h2 className="voice-story-modal-title">Your story matters.</h2>
                <p className="voice-story-modal-desc">Choose the thread your story belongs to. There is no wrong answer.</p>

                <div className="voice-story-modal-options">
                  <div 
                    className={`voice-story-modal-option ${selectedThread === 'Resilience' ? 'active' : ''}`}
                    onClick={() => setSelectedThread('Resilience')}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v10"></path><path d="M12 12l4-4"></path><path d="M12 12L8 8"></path><path d="M22 20H2"></path></svg>
                    <span>Resilience</span>
                  </div>
                  <div 
                    className={`voice-story-modal-option ${selectedThread === 'Love' ? 'active' : ''}`}
                    onClick={() => setSelectedThread('Love')}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                    <span>Love</span>
                  </div>
                  <div 
                    className={`voice-story-modal-option ${selectedThread === 'Hope' ? 'active' : ''}`}
                    onClick={() => setSelectedThread('Hope')}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                    <span>Hope</span>
                  </div>
                  <div 
                    className={`voice-story-modal-option ${selectedThread === 'Courage' ? 'active' : ''}`}
                    onClick={() => setSelectedThread('Courage')}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    <span>Courage</span>
                  </div>
                  <div 
                    className={`voice-story-modal-option ${selectedThread === 'Transformation' ? 'active' : ''}`}
                    onClick={() => setSelectedThread('Transformation')}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M16 12l-4-4-4 4M12 8v8"></path></svg>
                    <span>Transformation</span>
                  </div>
                </div>

                <button 
                  className="voice-story-modal-continue" 
                  disabled={!selectedThread}
                  onClick={() => setModalStep(2)}
                >
                  Continue
                </button>
              </>
            ) : (
              <>
                <div className="voice-story-modal-progress">
                  <div className="voice-story-modal-progress-filled"></div>
                  <div className="voice-story-modal-progress-filled"></div>
                </div>

                <p className="voice-story-modal-step">STEP 2 OF 2 &middot; {selectedThread}</p>
                <h2 className="voice-story-modal-title">Tell us what happened.</h2>
                <p className="voice-story-modal-desc">Write in your own voice. You can be anonymous.</p>

                <div className="voice-story-modal-form">
                  <input type="text" placeholder="A title for your story" className="voice-story-modal-input" value={voiceFormData.title} onChange={e => setVoiceFormData({...voiceFormData, title: e.target.value})} />
                  <textarea placeholder="Write your story here. There is no minimum. There is no template." className="voice-story-modal-textarea" value={voiceFormData.story} onChange={e => setVoiceFormData({...voiceFormData, story: e.target.value})}></textarea>
                  <input type="text" placeholder="Your name (or 'Anonymous')" className="voice-story-modal-input" value={voiceFormData.name} onChange={e => setVoiceFormData({...voiceFormData, name: e.target.value})} />
                  <input type="text" placeholder="Your location (optional)" className="voice-story-modal-input" value={voiceFormData.location} onChange={e => setVoiceFormData({...voiceFormData, location: e.target.value})} />
                  
                  <div className="voice-story-modal-file-upload">
                    <label>Upload an image (optional)</label>
                    <input type="file" accept="image/png, image/jpeg, image/jpg, image/avif, image/webp" className="voice-story-modal-input file-input" onChange={e => setVoiceImageFile(e.target.files[0])} />
                  </div>
                </div>

                {submitStoryMessage && (
                  <p style={{ color: submitStoryMessage.includes("Error") ? 'red' : 'green', fontSize: '14px', marginBottom: '16px' }}>{submitStoryMessage}</p>
                )}

                <div className="voice-story-modal-actions">
                  <button className="voice-story-modal-back" onClick={() => setModalStep(1)} disabled={isSubmittingStory}>Back</button>
                  <button className="voice-story-modal-submit" onClick={handleSubmitStory} disabled={isSubmittingStory}>
                    {isSubmittingStory ? "Submitting..." : "Submit Your Story"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* </div> */}
    </div>
  );
}

function InfoCard({ title, text }) {
  return (
    <div className="info-card">
      <h3 className="card-title">{title}</h3>
      <p className="card-text">{text}</p>
    </div>
  );
}